import React from "react";

export default function Section({ children, title, desc, className }) {
  return (
    <>
      <section className={`py-20 px-6 lg:px-8 max-sm:py-12 max-sm:px-6 ${className}`}>
        <div className={`container flex flex-col mx-auto max-w-7xl ${className}`}>
          <div className="mb-8">
            <h2
              className={`tracking-wide text-3xl lg:text-4xl font-semibold text-[#333] mb-4 ${className}`}
            >
              {title.toUpperCase()}
            </h2>
            <div className="h-[3px] w-16 bg-[#dbdbdb] mb-6"></div>
            <p
              className={`text-gray-500 sm:leading-loose text-lg max-md:px-0 max-w-4xl ${className} text-justify`}
            >
              {desc}
            </p>
          </div>
          <div className="mt-6">
            {children}
          </div>
        </div>
      </section>
    </>
  );
}
